import React from "react";
import PropTypes from "prop-types";
import Checkbox from "@material-ui/core/Checkbox";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.grey[400],
        border: "none",
        "&:hover": {
            boxShadow: "none",
            border: "none",
        },
        "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.32)",
        },
        "&.MuiCheckbox-colorPrimary": {
            color: theme.palette.green,
            "&:hover": {
                background: "rgba(112, 194, 118, 0.12)",
            },
        },
        "&.MuiCheckbox-colorSecondary": {
            "&.Mui-checked": {
                color: theme.palette.secondary["700"],
            },
            "&:hover": {
                background: "rgba(163, 156, 145, 0.12)",
            },
        },
    }
}));

const CustomCheckbox = ({checked, color, disabled, required, inputProps, className, style, onChange, ...props}) => {

    const classes = useStyles();

    const getClassName = () => {
        const classNames = [classes.root];
        if (className) {
            classNames.push(className);
        }

        return classNames.join(" ");
    };

    return (
        <Checkbox
            checked={checked}
            color={color}
            disabled={disabled}
            required={required}
            inputProps={inputProps}
            className={getClassName()}
            style={style}
            onChange={onChange}
            {...props}
        />
    );
};

CustomCheckbox.defaultProps = {
    color: "primary"
};

CustomCheckbox.propTypes = {
    checked: PropTypes.bool,
    color: PropTypes.oneOf(["primary", "secondary"]),
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    inputProps: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.string,
    onChange: PropTypes.func,
    props: PropTypes.any
};

export default CustomCheckbox;
